import type { DatasetImageUploadProps } from "./dataset-image-upload.type";

import UploadFile from "@/modules/upload-file";
import { ImageSkeleton } from "@/ui/image-skeleton";

import { useDatasetImageUpload } from "./dataset-image-upload.hook";

import "./dataset-image-upload.style.less";

export const DatasetImageUpload = (props: DatasetImageUploadProps) => {
  const { loading, uploadProps } = useDatasetImageUpload(props);

  return (
    <div className="dataset-image-upload">
      <UploadFile
        layout="draggerRow"
        data-testid="dataset-image-upload"
        {...uploadProps}
      />
      {loading && <ImageSkeleton />}
    </div>
  );
};
